"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var events_1 = require("events");

var v4_1 = __importDefault(require("uuid/v4"));

var PostTransactionResolver_1 = require("../PostTransactionResolver");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var Entity_1 = require("./Entity");

var utils_1 = require("../utils");

var Event;

(function (Event) {
  Event["StatusChange"] = "StatusChange";
})(Event || (Event = {})); // TODO @RafaelVidaurre: Cleanup code

/**
 * @hidden
 */


var mapValuesDeep = function mapValuesDeep(obj, fn) {
  return lodash_1.mapValues(obj, function (val, key) {
    return lodash_1.isPlainObject(val) ? mapValuesDeep(val, fn) : fn(val, key, obj);
  });
}; // TODO @monitz87: Make properties private where appliccable

/**
 * Wrapper class for a Polymath Transaction
 */


var PolyTransaction =
/*#__PURE__*/
function (_Entity_1$Entity) {
  _inherits(PolyTransaction, _Entity_1$Entity);

  /**
   * Creates a poly transaction
   */
  function PolyTransaction(transaction, transactionQueue) {
    var _this;

    _classCallCheck(this, PolyTransaction);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PolyTransaction).call(this));
    /**
     * current status of the transaction
     */

    _this.status = types_1.TransactionStatus.Idle;
    /**
     * @hidden
     */

    _this.postResolvers = [];
    /**
     * Subscribe to status changes
     *
     * @param listener - callback function that will be called whenever the status changes
     *
     * @returns unsubscribe function
     */

    _this.onStatusChange = function (listener) {
      _this.emitter.on(Event.StatusChange, listener);

      return function () {
        _this.emitter.removeListener(Event.StatusChange, listener);
      };
    };
    /**
     * @hidden
     */


    _this.resolve = function () {};
    /**
     * @hidden
     */


    _this.reject = function () {};
    /**
     * @hidden
     */


    _this.updateStatus = function (status) {
      _this.status = status;
      /* eslint-disable default-case */

      switch (status) {
        case types_1.TransactionStatus.Unapproved:
          {
            _this.emitter.emit(Event.StatusChange, _assertThisInitialized(_this));

            return;
          }

        case types_1.TransactionStatus.Running:
          {
            _this.emitter.emit(Event.StatusChange, _assertThisInitialized(_this));

            return;
          }

        case types_1.TransactionStatus.Succeeded:
          {
            _this.emitter.emit(Event.StatusChange, _assertThisInitialized(_this));

            return;
          }

        case types_1.TransactionStatus.Failed:
          {
            _this.emitter.emit(Event.StatusChange, _assertThisInitialized(_this), _this.error);

            return;
          }

        case types_1.TransactionStatus.Rejected:
          {
            _this.emitter.emit(Event.StatusChange, _assertThisInitialized(_this));
          }
      }
      /* eslint-enable default-case */

    };

    if (transaction.postTransactionResolvers) {
      _this.postResolvers = transaction.postTransactionResolvers;
    }

    _this.emitter = new events_1.EventEmitter();
    _this.tag = transaction.tag || types_1.PolyTransactionTag.Any;
    _this.method = transaction.method;
    _this.args = transaction.args;
    _this.transactionQueue = transactionQueue;
    _this.promise = new Promise(function (res, rej) {
      _this.resolve = res;
      _this.reject = rej;
    });
    _this.uid = PolyTransaction.generateId();
    return _this;
  }
  /**
   * Generate the Poly Transaction's UUID from its identifying properties
   */


  _createClass(PolyTransaction, [{
    key: "toPojo",

    /**
     * Convert entity to a POJO (Plain Old Javascript Object)
     */
    value: function toPojo() {
      var uid = this.uid,
          status = this.status,
          tag = this.tag,
          receipt = this.receipt,
          error = this.error,
          txHash = this.txHash,
          transactionQueue = this.transactionQueue,
          args = this.args;
      var transactionQueueUid = transactionQueue.uid; // do not expose arguments that haven't been resolved
      // TODO @monitz87: type this correctly

      var filteredArgs = lodash_1.pickBy(args, function (arg) {
        return !PostTransactionResolver_1.isPostTransactionResolver(arg);
      });
      return {
        uid: uid,
        transactionQueueUid: transactionQueueUid,
        status: status,
        tag: tag,
        txHash: txHash,
        receipt: receipt,
        error: error,

        /*
         * NOTE @monitz87: we intentionally expose the args as any for the end user
         * until we figure out how to type this properly
         */
        args: filteredArgs
      };
    }
    /**
     * Run the poly transaction and update the transaction status
     */

  }, {
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var receipt, error;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.internalRun();

              case 3:
                receipt = _context.sent;
                this.receipt = receipt;
                this.updateStatus(types_1.TransactionStatus.Succeeded);
                this.resolve(receipt);
                _context.next = 15;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                error = _context.t0;

                if (!(_context.t0 instanceof PolymathError_1.PolymathError)) {
                  error = new PolymathError_1.PolymathError({
                    code: types_1.ErrorCode.TransactionReverted,
                    message: _context.t0.message
                  });
                }

                if (_context.t0.code === types_1.ErrorCode.TransactionRejectedByUser) {
                  this.updateStatus(types_1.TransactionStatus.Rejected);
                } else {
                  this.updateStatus(types_1.TransactionStatus.Failed);
                }

                this.reject(error);

              case 15:
                _context.next = 17;
                return this.promise;

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9]]);
      }));
    }
    /**
     * @hidden
     */

  }, {
    key: "internalRun",
    value: function internalRun() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var unwrappedArgs, method, response, returnedMethod, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.updateStatus(types_1.TransactionStatus.Unapproved);
                unwrappedArgs = this.unwrapArgs(this.args);
                method = this.method;

                if (!(method instanceof Function)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 6;
                return method(unwrappedArgs);

              case 6:
                response = _context2.sent;
                _context2.next = 15;
                break;

              case 9:
                _context2.next = 11;
                return method.futureMethod(method.futureValue.result);

              case 11:
                returnedMethod = _context2.sent;
                _context2.next = 14;
                return returnedMethod(unwrappedArgs);

              case 14:
                response = _context2.sent;

              case 15:
                // Set the Transaction as Running once it is approved by the user
                this.updateStatus(types_1.TransactionStatus.Running);
                _context2.prev = 16;

                if (!(typeof response !== 'string')) {
                  _context2.next = 24;
                  break;
                }

                this.txHash = response.txHash;
                _context2.next = 21;
                return response.receiptAsync;

              case 21:
                result = _context2.sent;
                _context2.next = 25;
                break;

              case 24:
                result = response;

              case 25:
                _context2.next = 31;
                break;

              case 27:
                _context2.prev = 27;
                _context2.t0 = _context2["catch"](16);

                // Wrap with PolymathError
                if (_context2.t0.message.indexOf('MetaMask Tx Signature') > -1) {
                  this.error = new PolymathError_1.PolymathError({
                    code: types_1.ErrorCode.TransactionRejectedByUser
                  });
                } else {
                  this.error = new PolymathError_1.PolymathError({
                    code: types_1.ErrorCode.FatalError,
                    message: _context2.t0.message
                  });
                }

                throw this.error;

              case 31:
                _context2.next = 33;
                return Promise.all(this.postResolvers.map(function (resolver) {
                  return resolver.run(result);
                }));

              case 33:
                return _context2.abrupt("return", result);

              case 34:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[16, 27]]);
      }));
    }
    /**
     * @hidden
     */

  }, {
    key: "unwrapArg",
    value: function unwrapArg(arg) {
      if (PostTransactionResolver_1.isPostTransactionResolver(arg)) {
        return arg.result;
      }

      return arg;
    }
    /**
     * @hidden
     */

  }, {
    key: "unwrapArgs",
    value: function unwrapArgs(args) {
      var _this2 = this;

      return lodash_1.mapValues(args, function (arg) {
        return lodash_1.isPlainObject(arg) ? mapValuesDeep(arg, function (val) {
          return _this2.unwrapArg(val);
        }) : _this2.unwrapArg(arg);
      });
    }
    /**
     * Hydrate the entity
     */

  }, {
    key: "_refresh",
    value: function _refresh() {}
  }], [{
    key: "generateId",
    value: function generateId() {
      return utils_1.serialize('transaction', {
        random: v4_1.default()
      });
    }
  }]);

  return PolyTransaction;
}(Entity_1.Entity);

exports.PolyTransaction = PolyTransaction;